import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {fullName} from 'shared/tools';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import {onboarding, offboarding} from 'main/components/tasks';

class TaskTemplate extends DomainObject {
  config;

  id;
  name = '';
  assigneeType = 'employee';
  relativeDueDateValue = null;
  relativeDueDateUnit = null;
  description;
  lexicalState;
  assigneeEmployee;
  assigneeUser;
  templateType;
  draftEmployeeId;
  parentTemplateId;
  employeeGroupId;
  default = false;

  constructor(other) {
    super();

    makeObservable(this, {
      config: observable,
      id: observable,
      name: observable,
      assigneeType: observable,
      relativeDueDateValue: observable,
      relativeDueDateUnit: observable,
      description: observable,
      lexicalState: observable,
      assigneeEmployee: observable,
      assigneeUser: observable,
      templateType: observable,
      draftEmployeeId: observable,
      parentTemplateId: observable,
      employeeGroupId: observable,
      default: observable,
      isSpecificPerson: computed,
      assigneeName: computed,
      assigneeId: computed,
      dueDateValue: computed,
      assignee: computed
    });

    this.merge(other);
  }

  _afterMerge() {
    this.clientId = this.id ? this.id : this.clientId ? this.clientId : uuidv4();
    if (!this.draftEmployeeId) {
      this.parentTemplateId = this.id;
    }

    if (this.templateType === 'onboarding') {
      this.config = onboarding;
    } else {
      this.config = offboarding;
    }
  }

  get isSpecificPerson() {
    return this.assigneeType !== 'manager' && this.assigneeType !== 'employee';
  }

  get assigneeName() {
    if (this.assignee) {
      return fullName(this.assignee);
    }
    return '';
  }

  get assigneeId() {
    if (this.assignee) {
      return this.assignee.id;
    }
    return null;
  }

  get dueDateValue() {
    const invalidNumber = _.isNaN(parseInt(this.relativeDueDateValue));
    return invalidNumber ? '' : Math.abs(this.relativeDueDateValue);
  }

  get assignee() {
    return this.assigneeEmployee || this.assigneeUser;
  }

  toJS() {
    const json = super.toJS();
    if (json.relativeDueDateValue === 0) {
      json.relativeDueDateUnit = 'days';
    }
    return json;
  }
}

export default TaskTemplate;
